<template>
  <div>
    <slot v-bind:open="open" />
    <Modal :show="show" @close="close" size="md">
      <AddItemModal
        :warehouses="warehouseList"
        :order-id="orderId"
        @itemAdded="onItemAdded"
        @closeModal="show = false" />
    </Modal>
  </div>
</template>

<script>
import Modal from "../../../../Shared/Modal.vue";
import AddItemModal from "../AddItemModal.vue";
import Dialog from "../../../../Shared/Dialog.vue";

export default {
  name: 'AddItemToOrder',
  components: {Dialog, AddItemModal, Modal},

  props: {
    warehouseList: Array,
    orderId: Number,
  },
  data() {
    return {
      show: false,
    }
  },

  methods: {
    open() {
      this.show = true
    },
    close() {
      this.show = false
    },

    onItemAdded() {
      window.location.reload();
    }
  }
}
</script>
